// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Определение цветов и других значений в виде кастомных свойств */
:root {
  --primary-purple: #2e1a47;
  --primary-text: rgba(65, 65, 65, 0.9);
  --secondary-text: rgba(65, 65, 65, 0.8);
  --primary-white: rgba(255, 255, 255, 0.7);
  --grey-border: rgb(204, 201, 201);
}

/* CSS Reset */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike,  sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
  display: block;
}
/* HTML5 hidden-attribute fix for newer browsers */
*[hidden] {
    display: none;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}


body { 
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background-color: #fff;

}

.cards-list-wrap {
  max-width: 1640px;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.cards-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
}

.card {
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  padding-right: 15px;
  width: 25%;
}

/* Медиа-запросы для .card */
@media (max-width: 640px) { /* Mobile */
  .card {
    width: 100%;
  }
}

@media (min-width: 640px) { /* Tablet */
  .card {
    width: 50%;
  }
}

@media (min-width: 960px) { /* Desktop */
  .card {
    width: 33.33%;
  }
}

@media (min-width: 1200px) { /* Wide Desktop */
  .card {
    width: 25%;
  }
}

.card-image-container {
  overflow: hidden;
}

.card-image--wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 450px;
}

/* Медиа-запросы для .card-image--wrap */
@media (max-width: 640px) {
  .card-image--wrap {
    height: 600px;
  }
}

@media (min-width: 640px) {
  .card-image--wrap {
    height: 550px;
  }
}

@media (min-width: 960px) {
  .card-image--wrap {
    height: 450px;
  }
}

.card-image--wrap h3 {
  background-color: var(--primary-purple);
  color: #fff;
  padding: 12px;
  max-width: 200px;
  position: absolute;
  bottom: 100px;
  font-weight: 400;
  font-size: 22px;
  text-align: center;
}

.card-info {
  display: flex;
  padding: 15px 0;
  color: rgba(65,65,65,.9);
  border-top: 1px solid var(--grey-border);
  line-height: 20px;
  justify-content: space-between;
}
.header {
  max-width: 1640px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  min-height: 40px;
  padding: 15px 15px 5px;
  background-color: #fff;
}

.locale-link {
  padding: 5px 10px;
  background-color: #2e1a47;
  border-radius: 5px;
  color: #fff;
}

.locale-link {
  padding: 5px 10px;
  background-color: #2e1a47;
  border-radius: 5px;
  color: #fff;
}

.card-nums-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 6px;
}

.card-nums-wrap span, .card-nums-wrap p {
  color: rgba(65, 65, 65, 0.9); /* primary-text */
}

.card-nums-wrap .currency {
  margin-right: 2px;
  font-weight: 600;
  font-family: "inter";
  font-size: 17px;
}

.menu-image {
  transform: scale(1.1) translateY(25px);
  object-fit: cover;
}


.card-info--right {
  flex: 0 1 30%;
  text-align: center;
}

.card-info--right h4 {
  color: rgba(65, 65, 65, 0.9); /* primary-text */
  font-weight: 800;
  font-size: 16px;
}

.card-info--left h4 {
  color: rgba(65, 65, 65, 0.9); /* primary-text */
  font-weight: 800;
  font-size: 16px;
}

/* img sizes="(max-width: 640px) 100%, (min-width: 640px) 50%,(min-width: 960px) 33%,(min-width: 1200px) 25%" */
img {
  width: 100%;
  height: auto;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m:
    conic-gradient(#0000 10%, #000),
    linear-gradient(#000 0 0) content-box;
  mask: var(--_m);
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,yBAAyB;EACzB,qCAAqC;EACrC,uCAAuC;EACvC,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA,cAAc;AACd;;;;;;;;;;;;;EAaE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;AACA,gDAAgD;AAChD;;EAEE,cAAc;AAChB;AACA,kDAAkD;AAClD;IACI,aAAa;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;;AAGA;EACE,SAAS;EACT,iCAAiC;EACjC,sBAAsB;;AAExB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B,4BAA4B,WAAW;EACrC;IACE,WAAW;EACb;AACF;;AAEA,4BAA4B,WAAW;EACrC;IACE,UAAU;EACZ;AACF;;AAEA,4BAA4B,YAAY;EACtC;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B,iBAAiB;EAC5C;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,4BAA4B,EAAE,iBAAiB;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4BAA4B,EAAE,iBAAiB;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B,EAAE,iBAAiB;EAC/C,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+GAA+G;AAC/G;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;;yCAEuC;EAEvC,eAAe;EAEf,wBAAwB;EACxB,gCAAgC;AAClC","sourcesContent":["/* Определение цветов и других значений в виде кастомных свойств */\n:root {\n  --primary-purple: #2e1a47;\n  --primary-text: rgba(65, 65, 65, 0.9);\n  --secondary-text: rgba(65, 65, 65, 0.8);\n  --primary-white: rgba(255, 255, 255, 0.7);\n  --grey-border: rgb(204, 201, 201);\n}\n\n/* CSS Reset */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike,  sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed, \nfigure, figcaption, footer, header, hgroup, \nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure, \nfooter, header, hgroup, menu, nav, section {\n  display: block;\n}\n/* HTML5 hidden-attribute fix for newer browsers */\n*[hidden] {\n    display: none;\n}\nbody {\n  line-height: 1;\n}\nol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n\nbody { \n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  background-color: #fff;\n\n}\n\n.cards-list-wrap {\n  max-width: 1640px;\n  margin: 0 auto;\n  padding-top: 10px;\n  display: flex;\n  justify-content: center;\n  background-color: #fff;\n}\n\n.cards-list {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  justify-content: center;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  padding-left: 15px;\n  padding-right: 15px;\n  width: 25%;\n}\n\n/* Медиа-запросы для .card */\n@media (max-width: 640px) { /* Mobile */\n  .card {\n    width: 100%;\n  }\n}\n\n@media (min-width: 640px) { /* Tablet */\n  .card {\n    width: 50%;\n  }\n}\n\n@media (min-width: 960px) { /* Desktop */\n  .card {\n    width: 33.33%;\n  }\n}\n\n@media (min-width: 1200px) { /* Wide Desktop */\n  .card {\n    width: 25%;\n  }\n}\n\n.card-image-container {\n  overflow: hidden;\n}\n\n.card-image--wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 450px;\n}\n\n/* Медиа-запросы для .card-image--wrap */\n@media (max-width: 640px) {\n  .card-image--wrap {\n    height: 600px;\n  }\n}\n\n@media (min-width: 640px) {\n  .card-image--wrap {\n    height: 550px;\n  }\n}\n\n@media (min-width: 960px) {\n  .card-image--wrap {\n    height: 450px;\n  }\n}\n\n.card-image--wrap h3 {\n  background-color: var(--primary-purple);\n  color: #fff;\n  padding: 12px;\n  max-width: 200px;\n  position: absolute;\n  bottom: 100px;\n  font-weight: 400;\n  font-size: 22px;\n  text-align: center;\n}\n\n.card-info {\n  display: flex;\n  padding: 15px 0;\n  color: rgba(65,65,65,.9);\n  border-top: 1px solid var(--grey-border);\n  line-height: 20px;\n  justify-content: space-between;\n}\n.header {\n  max-width: 1640px;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  min-height: 40px;\n  padding: 15px 15px 5px;\n  background-color: #fff;\n}\n\n.locale-link {\n  padding: 5px 10px;\n  background-color: #2e1a47;\n  border-radius: 5px;\n  color: #fff;\n}\n\n.locale-link {\n  padding: 5px 10px;\n  background-color: #2e1a47;\n  border-radius: 5px;\n  color: #fff;\n}\n\n.card-nums-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.card-nums-wrap span, .card-nums-wrap p {\n  color: rgba(65, 65, 65, 0.9); /* primary-text */\n}\n\n.card-nums-wrap .currency {\n  margin-right: 2px;\n  font-weight: 600;\n  font-family: \"inter\";\n  font-size: 17px;\n}\n\n.menu-image {\n  transform: scale(1.1) translateY(25px);\n  object-fit: cover;\n}\n\n\n.card-info--right {\n  flex: 0 1 30%;\n  text-align: center;\n}\n\n.card-info--right h4 {\n  color: rgba(65, 65, 65, 0.9); /* primary-text */\n  font-weight: 800;\n  font-size: 16px;\n}\n\n.card-info--left h4 {\n  color: rgba(65, 65, 65, 0.9); /* primary-text */\n  font-weight: 800;\n  font-size: 16px;\n}\n\n/* img sizes=\"(max-width: 640px) 100%, (min-width: 640px) 50%,(min-width: 960px) 33%,(min-width: 1200px) 25%\" */\nimg {\n  width: 100%;\n  height: auto;\n}\n\n.loader {\n  width: 50px;\n  padding: 8px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #25b09b;\n  --_m:\n    conic-gradient(#0000 10%, #000),\n    linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  mask-composite: subtract;\n  animation: l3 1s infinite linear;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
